// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1TNZY","content":"LayoutSettings_content__23ghN"};